export default {
    env: "prod",
    baseUrlWithoutAuth: "https://www.airtel.in/chatbot/",
    baseUrls: {
        ONLINE: {
            // DIGITAL_PROFILE_CONTEXT_URI: "https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/"
            DIGITAL_PROFILE_CONTEXT_URI: "https://digi-api.airtel.in/app/wl-service/airtel-digital-profile/rest/"
        },
        HELPSUPPORT: {
            default: "https://www.airtel.in",
            NEW_DIGITAL_PROFILE_CONTEXT_URI: "https://digi-api.airtel.in/app/wl-service/airtel-helpsupport/rest/"
        },
        CHATBOT: {
            default: "https://www.airtel.in/chatbot",
            CHATBOT_CONTEXT_URI: "/chatMediator/hns/v1"
        },
        CONSENT_SERVICE: {
            CONTEXT_URI: "https://digi-api.airtel.in/cs/"
        }
    },
    authPrefixPath: {
        HELPSUPPORT: "/s"
    },
    routerBasename: '/',
    parentUrl: '',
    staticAssetsBasePath: "https://assets.airtel.in",
    sentry: {
        enabled: true,
        environment: "production",
        dsn: "https://a9687e69f71d499693fa504672ccb013@digi-api.airtel.in/sentry/91"
    }
};
